import React, { useState, useEffect } from "react";
import Input from "components/ui/Input";
import Button from "components/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  createShippingSettingService,
  getShippingService,
} from "redux/services/general_service";

const ShippingSettingsModal = ({ isOpen, onClose, area }) => {
  const dispatch = useDispatch();

  const { shippingOfArea } = useSelector((state) => state.general);

  const [costInfo, setCostInfo] = useState("");
  const [expectedTime, setExpectedTime] = useState("");

  useEffect(() => {
    if (area) {
      setCostInfo("");
      setExpectedTime("");
    }
  }, [area]);

  useEffect(() => {
    dispatch(getShippingService(area?.id));
    console.log(area);
  }, []);

  if (!isOpen || !area) return null;

  const handleSubmit = () => {
    const payload = {
      province_id: area.id,
      cost_info: costInfo,
      expected_time: expectedTime,
    };
    dispatch(createShippingSettingService(payload)).then((response) => {
      if (response.payload?.status == 200) {
     
        toast("تم إضافة معلومات الشحن  بنجاح");
        dispatch(getAllgovernoratesService());
           onClose();
      }
    });
 
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h2 className="text-lg font-semibold mb-4">
          إعدادات الشحن – {area?.translations?.ar?.name}
        </h2>

        <div className="space-y-4">
          <Input
            label="التكلفة"
            value={costInfo}
            onChange={(e) => setCostInfo(e.target.value)}
            placeholder="مثال: 10$"
          />

          <Input
            label="الوقت المتوقع"
            value={expectedTime}
            onChange={(e) => setExpectedTime(e.target.value)}
            placeholder="مثال: 2-3 أيام"
          />
        </div>

        <div className="flex justify-end space-x-2 mt-6">
          <Button variant="outline" onClick={onClose}>
            إلغاء
          </Button>
          <Button onClick={handleSubmit}>حفظ</Button>
        </div>
      </div>
    </div>
  );
};

export default ShippingSettingsModal;
